<template>
  <div>
    <el-row :gutter="24" class="content-bottom-padded search-form-row">
      <el-col :xs="24" :sm="12" :md="3">
        <el-input
          placeholder="订单号"
          v-model="params.order_id"
          clearable
          size="mini"
          @keyup.enter.native="searchData"
          @clear="searchData"
          class="search-form-item"
        />
      </el-col>
      <el-col :xs="24" :sm="12" :md="3">
        <el-input
          placeholder="团长优选会员ID"
          v-model="params.yx_user_id"
          clearable
          size="mini"
          @keyup.enter.native="searchData"
          @clear="searchData"
          class="search-form-item"
        />
      </el-col>
      <el-col :xs="24" :sm="12" :md="3">
        <el-input
          placeholder="下单人手机号"
          v-model="params.invitee_mobile"
          clearable
          size="mini"
          @keyup.enter.native="searchData"
          @clear="searchData"
          class="search-form-item"
        />
      </el-col>
      <el-col :xs="24" :sm="12" :md="3">
        <el-select v-model="params.status" placeholder="状态" size="mini" @change="searchData" class="search-form-item">
          <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :sm="24" :md="6">
        <el-date-picker
          v-model="created"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          @change="dateChange"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          size="mini"
          class="search-form-item search-form-date"
        >
        </el-date-picker>
      </el-col>
      <el-col :xs="24" :sm="24" :md="6" class="search-form-actions">
        <el-button type="primary" size="mini" @click="searchData">搜索</el-button>
        <el-button size="mini" @click="exportData" :loading="exportLoading">导出</el-button>
        <el-button type="warning" size="mini" @click="importDialogVisible = true">导入员工数据</el-button>
      </el-col>
    </el-row>

    <el-table :data="dataList" :height="wheight - 190" v-loading="loading">
      <el-table-column prop="id" label="ID" width="70" />
      <!-- <el-table-column prop="advance_id" label="资金明细ID" width="100" /> -->
      <el-table-column prop="order_id" label="订单号" width="190" />
      <el-table-column prop="yx_user_id" label="团长优选会员ID" width="140" />
      <el-table-column prop="reward_amount" label="应发金额" width="100" />
      <!-- <el-table-column prop="invitee_yx_user_id" label="被邀请人优选用户ID" width="130" /> -->
      <!-- <el-table-column prop="invitee_yk_user_id" label="被邀请人到家用户ID" width="130" /> -->
      <el-table-column prop="invitee_mobile" label="下单人手机号" width="120" />
      <el-table-column prop="status" label="状态" width="120">
        <template slot-scope="scope">
          <span :class="getStatusClass(scope.row.status)">{{ statusMap[scope.row.status] || scope.row.status }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="audit_remark" label="审核备注" min-width="160" />
      <el-table-column prop="audit_at" label="审核时间" width="160">
        <template slot-scope="scope">
          {{ formatTime(scope.row.audit_at) }}
        </template>
      </el-table-column>
      <el-table-column prop="released_at" label="发放时间" width="160">
        <template slot-scope="scope">
          {{ formatTime(scope.row.released_at) }}
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="创建时间" width="160">
        <template slot-scope="scope">
          {{ formatTime(scope.row.created_at) }}
        </template>
      </el-table-column>
      <el-table-column prop="updated_at" label="更新时间" width="160">
        <template slot-scope="scope">
          {{ formatTime(scope.row.updated_at) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="260" fixed="right">
        <template slot-scope="scope">
          <template v-if="scope.row.status === 0">
            <el-button type="text" size="mini" @click="handleAudit(scope.row, 1)">通过</el-button>
            <el-button type="text" size="mini" @click="handleAudit(scope.row, 3)">审核不通过</el-button>
          </template>
          <el-button type="text" size="mini" @click="handleRemark(scope.row)">备注</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div v-if="total_count > params.pagesize" class="content-center content-top-padded">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page.sync="params.page"
        :page-sizes="[10, 20, 50]"
        :total="total_count"
        :page-size="params.pagesize"
      >
      </el-pagination>
    </div>

    <el-dialog title="导入员工数据" :visible.sync="importDialogVisible" width="620px" append-to-body :close-on-click-modal="false">
      <el-form label-width="100px">
        <el-form-item label="生效月份">
          <el-input v-model="importMonth" size="small" style="width: 200px;" disabled />
        </el-form-item>
        <el-form-item label="员工文件" required>
          <el-upload
            action=""
            :on-change="importFileChange"
            :auto-upload="false"
            :show-file-list="true"
            :limit="1"
            :on-exceed="() => $message.warning('只能上传一个文件')"
            accept=".xlsx"
            :file-list="importFileList"
          >
            <el-button size="small" type="primary">选择文件</el-button>
            <span slot="tip" class="el-upload__tip" style="margin-left: 10px;">仅支持 .xlsx 格式</span>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入模板">
          <a href="https://img1.yaoking.cn/000/%E5%91%98%E5%B7%A5%E4%BF%A1%E6%81%AF%E6%A8%A1%E6%9D%BF.xlsx" target="_blank" style="color: #409eff;">下载员工信息模板</a>
        </el-form-item>
      </el-form>
      <el-alert
        title="说明：每月25号业务人员上传最新版员工数据，员工数据按月份全量覆盖导入，导入成功后程序将自动核验团长奖励，若被邀请人为员工时，则该笔奖励将审核不通过;次日0点(即26号0点)程序将自动处理<已通过待发放>的奖励并写入对应团长资金明细。"
        type="warning"
        :closable="false"
        show-icon
        style="margin-bottom: 10px;"
      />
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="importDialogVisible = false">取消</el-button>
        <el-button type="primary" size="mini" @click="confirmImport" :loading="importLoading">确认导入</el-button>
      </span>
    </el-dialog>

    <el-dialog title="审核备注" :visible.sync="remarkDialogVisible" width="450px" append-to-body>
      <el-input v-model="remarkContent" type="textarea" :rows="4" placeholder="添加或修改审核备注"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="remarkDialogVisible = false">取消</el-button>
        <el-button type="primary" size="mini" @click="confirmRemark">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getRewardPendingList, rewardPendingAudit, rewardPendingUpdateRemark, rewardPendingListExport, importRewardEmployee } from '../../../api/sharer'

const STATUS_PENDING = 0
const STATUS_APPROVED = 1
const STATUS_RELEASED = 2
const STATUS_REJECTED = 3

export default {
  name: 'RewardPendingList',
  data () {
    return {
      loading: false,
      exportLoading: false,
      total_count: 0,
      params: {
        page: 1,
        pagesize: 20,
        order_id: '',
        yx_user_id: '',
        invitee_mobile: '',
        status: '全部',
        time_start_begin: '',
        time_start_end: ''
      },
      statusOptions: [
        { label: '全部', value: '全部' },
        { label: '待审核', value: STATUS_PENDING },
        { label: '已通过待发放', value: STATUS_APPROVED },
        { label: '已发放', value: STATUS_RELEASED },
        { label: '审核不通过', value: STATUS_REJECTED }
      ],
      statusMap: {
        [STATUS_PENDING]: '待审核',
        [STATUS_APPROVED]: '已通过待发放',
        [STATUS_RELEASED]: '已发放',
        [STATUS_REJECTED]: '审核不通过'
      },
      created: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      dataList: [],
      remarkDialogVisible: false,
      remarkContent: '',
      pendingRemarkRow: null,
      importDialogVisible: false,
      importLoading: false,
      importMonth: (() => { const d = new Date(); return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') })(),
      importFileList: [],
      importFile: null
    }
  },
  computed: {
    ...mapGetters(['wheight'])
  },
  methods: {
    getDataList () {
      this.loading = true
      const req = { ...this.params }
      if (req.status === '全部') req.status = ''
      getRewardPendingList(req)
        .then(response => {
          this.dataList = response.data.data.list || []
          this.total_count = Number(response.data.data.total_count || 0)
          this.loading = false
        })
        .catch(() => {
          this.loading = false
          this.$message({ type: 'error', message: '获取团长奖励列表失败' })
        })
    },
    searchData () {
      this.params.page = 1
      this.getDataList()
    },
    dateChange (val) {
      if (val && val.length > 0) {
        this.params.time_start_begin = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
        this.params.time_start_end = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
      } else {
        this.params.time_start_begin = ''
        this.params.time_start_end = ''
      }
      this.params.page = 1
      this.getDataList()
    },
    dateStrToTimeStamp (str) {
      return Math.floor(Date.parse(new Date(str)) / 1000)
    },
    formatTime (ts) {
      if (!ts) return '—'
      const d = new Date(ts * 1000)
      return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0') + ' ' + String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0') + ':' + String(d.getSeconds()).padStart(2, '0')
    },
    getStatusClass (status) {
      const map = {
        [STATUS_APPROVED]: 'status-approved',   // 已通过待发放 - 蓝色
        [STATUS_RELEASED]: 'status-released',  // 已发放 - 绿色
        [STATUS_REJECTED]: 'status-rejected'   // 审核不通过 - 红色
      }
      return map[status] || ''  // 待审核 - 默认样式
    },
    handleCurrentChange (pageNum) {
      this.params.page = pageNum
      this.getDataList()
    },
    handleSizeChange (pageSize) {
      this.params.page = 1
      this.params.pagesize = pageSize
      this.getDataList()
    },
    handleAudit (row, status) {
      const isApprove = status === 1
      const msg = isApprove ? '确定通过该笔奖励？' : '确定审核不通过？'
      this.$confirm(msg, '审核确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return rewardPendingAudit({ id: row.id, status })
      }).then(() => {
        this.$message.success('审核成功')
        this.getDataList()
      }).catch(err => {
        if (err !== 'cancel') {
          this.$message.error((err && err.message) || '审核失败，请重试')
        }
      })
    },
    handleRemark (row) {
      this.pendingRemarkRow = row
      this.remarkContent = row.audit_remark || ''
      this.remarkDialogVisible = true
    },
    confirmRemark () {
      if (!this.pendingRemarkRow) return
      rewardPendingUpdateRemark({
        id: this.pendingRemarkRow.id,
        audit_remark: this.remarkContent
      })
        .then(() => {
          this.remarkDialogVisible = false
          this.$message.success('备注已保存')
          this.getDataList()
        })
        .catch(res => {
          this.$message.error((res && res.message) || '保存失败，请重试')
        })
    },
    exportData () {
      this.exportLoading = true
      const params = {
        order_id: this.params.order_id,
        yx_user_id: this.params.yx_user_id,
        invitee_mobile: this.params.invitee_mobile,
        status: this.params.status === '全部' ? '' : this.params.status,
        time_start_begin: this.params.time_start_begin,
        time_start_end: this.params.time_start_end
      }
      rewardPendingListExport(params)
        .then(response => {
          this.exportLoading = false
          const res = response.data || {}
          if (res.data.status) {
            this.$message.success(res.msg || '已加入执行队列，请在设置-导出列表-团长奖励待发放中下载')
          } else {
            this.$message.error(res.msg || '导出失败，请重试')
          }
        })
        .catch(() => {
          this.exportLoading = false
          this.$message.error('导出失败，请重试')
        })
    },
    importFileChange (file) {
      this.importFile = file.raw
      this.importFileList = [file]
    },
    confirmImport () {
      if (!this.importMonth) {
        this.$message.warning('请选择生效月份')
        return
      }
      if (!this.importFile) {
        this.$message.warning('请选择员工信息文件')
        return
      }
      this.$confirm(
        `确认导入 ${this.importMonth} 的员工数据？若该月份已有员工数据则将被覆盖，导入成功后将自动审核团长奖励。`,
        '导入确认',
        { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }
      ).then(() => {
        this.importLoading = true
        importRewardEmployee({
          isUploadFile: true,
          file: this.importFile,
          effective_month: this.importMonth
        }).then(response => {
          this.importLoading = false
          const res = response.data.data || {}
          if (res.status) {
            this.$message.success(res.msg || '导入成功')
            this.importDialogVisible = false
            this.importFile = null
            this.importFileList = []
            this.getDataList()
          } else {
            this.$message.error(res.message || '导入失败，请重试')
          }
        }).catch(err => {
          this.importLoading = false
          this.$message.error((err && err.message) || '导入失败，请重试')
        })
      }).catch(() => {})
    }
  },
  mounted () {
    this.getDataList()
  }
}
</script>

<style scoped lang="scss">
/* 审核状态文字样式 */
.status-approved {
  color: #409eff;
}
.status-released {
  color: #67c23a;
}
.status-rejected {
  color: #f56c6c;
}

.content-bottom-padded {
  margin-bottom: 20px;
}

.search-form-row {
  .search-form-item {
    width: 100%;
    max-width: 100%;
  }
  .search-form-date {
    min-width: 0;
  }
  .search-form-actions {
    margin-bottom: 8px;
    @media (min-width: 992px) {
      margin-bottom: 0;
    }
  }
  @media (max-width: 991px) {
    .el-col {
      margin-bottom: 12px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// reward_pending_list.vue?8e1e48f4